import React from 'react'

import '@/components/dashboard/misc/ArchStep.less'

const ArchStep = ({ maxium }) => {
    return (
        <div className='flow-panel'>
            {maxium && <div className='title'>基于风云3D数据实现了海冰信息的全自动提取</div>}
            <img src='/cesium/en_cesium/img/archStep.jpeg' alt='基于风云3D数据实现了海冰信息的全自动提取' className={maxium ? 'flow-img-maxium' : 'flow-img'} />
        </div>
    )
}

export default ArchStep